import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Masters - Only keeping the files that actually exist
import AddEdit_CityMaster from "../pages/Masters/AddEdit_CityMaster";
import PageList_CityMaster from "../pages/Masters/PageList_CityMaster";
import AddEdit_StateMaster from "../pages/Masters/AddEdit_StateMaster";
import PageList_StateMaster from "../pages/Masters/PageList_StateMaster";
import AddEdit_MemberMaster from "../pages/Masters/AddEdit_MemberMaster";
import PageList_MemberMaster from "../pages/Masters/PageList_MemberMaster";
import AddEdit_UserMaster from "../pages/Masters/AddEdit_UserMaster";
import PageList_UserMaster from "../pages/Masters/PageList_UserMaster";
import AddEdit_VehicleTypeMaster from "../pages/Masters/AddEdit_VehicleTypeMaster";
import PageList_VehicleTypeMaster from "../pages/Masters/PageList_VehicleTypeMaster";
import AddEdit_VehicleCategoryMaster from "../pages/Masters/AddEdit_VehicleCategoryMaster";
import PageList_VehicleCategoryMaster from "../pages/Masters/PageList_VehicleCategoryMaster";
import AddEdit_VehicleMaster from "../pages/Masters/AddEdit_VehicleMaster";
import PageList_VehicleMaster from "../pages/Masters/PageList_VehicleMaster";
import AddEdit_RateMaster from "../pages/Masters/AddEdit_RateMaster";
import PageList_RateMaster from "../pages/Masters/PageList_RateMaster";
import AddEdit_CouponMaster from "../pages/Masters/AddEdit_CouponMaster";
import PageList_CouponMaster from "../pages/Masters/PageList_CouponMaster";
import AddEdit_CommissionMaster from "../pages/Masters/AddEdit_CommissionMaster";
import PageList_CommissionMaster from "../pages/Masters/PageList_CommissionMaster";
import AddEdit_ChargeTypeMaster from "../pages/Masters/AddEdit_ChargeTypeMaster";
import PageList_ChargeTypeMaster from "../pages/Masters/PageList_ChargeTypeMaster";
import AddEdit_VehicleRateMaster from "../pages/Masters/AddEdit_VehicleRateMaster";


// Reports
import LedgerReport from "../pages/Reports/LedgerReport";
import BalanceSheet from "../pages/Reports/BalanceSheet";
import ProfitLossReport from "../pages/Reports/ProfitLossReport";

// Transactions
import AddEdit_WalletTopup from "../pages/Transactions/AddEdit_WalletTopup";
import VoucherEntry from "../pages/Transactions/VoucherEntry";

// Tools
import UpdateGlobalOptions from "../pages/Tools/UpdateGlobalOptions";
import AssignDriver from "pages/Working/AssignDriver";
import DriverForApproval from "../pages/Working/DriverForApproval";
import WithdrawalRequests from "../pages/Working/WithdrawalRequests";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // //profile
  { path: "/profile", component: <UserProfile /> },
  
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

  // Masters routes - Only keeping the files that actually exist
  { path: "/AddCityMaster", component: <AddEdit_CityMaster/> },
  { path: "/CityMaster", component: <PageList_CityMaster/> },

  { path: "/AddStateMaster", component: <AddEdit_StateMaster/> },
  { path: "/StateMaster", component: <PageList_StateMaster/> },

  { path: "/AddMemberMaster", component: <AddEdit_MemberMaster/> },
  { path: "/MemberMaster", component: <PageList_MemberMaster/> },

  { path: "/AddUserMaster", component: <AddEdit_UserMaster/> },
  { path: "/UserMaster", component: <PageList_UserMaster/> },

  { path: "/AddVehicleTypeMaster", component: <AddEdit_VehicleTypeMaster/> },
  { path: "/VehicleTypeMaster", component: <PageList_VehicleTypeMaster/> },

  { path: "/AddVehicleCategoryMaster", component: <AddEdit_VehicleCategoryMaster/> },
  { path: "/VehicleCategoryMaster", component: <PageList_VehicleCategoryMaster/> },

  { path: "/AddVehicleMaster", component: <AddEdit_VehicleMaster/> },
  { path: "/VehicleMaster", component: <PageList_VehicleMaster/> },

  { path: "/AddRateMaster", component: <AddEdit_RateMaster/> },
  { path: "/RateMaster", component: <PageList_RateMaster/> },

  { path: "/AddCouponMaster", component: <AddEdit_CouponMaster/> },
  { path: "/CouponMaster", component: <PageList_CouponMaster/> },

  { path: "/AddCommissionMaster", component: <AddEdit_CommissionMaster/> },
  { path: "/CommissionMaster", component: <PageList_CommissionMaster/> },

  { path: "/AddChargeTypeMaster", component: <AddEdit_ChargeTypeMaster/> },
  { path: "/ChargeTypeMaster", component: <PageList_ChargeTypeMaster/> },

  { path: "/VehicleRateMaster", component: <AddEdit_VehicleRateMaster/> },
  { path: "/WalletTopup", component: <AddEdit_WalletTopup/> },
  { path: "/VoucherEntry", component: <VoucherEntry/> },
  { path: "/AssignDriver", component: <AssignDriver/> },
  { path: "/DriverForApproval", component: <DriverForApproval/> },
  { path: "/WithdrawalRequests", component: <WithdrawalRequests/> },


  // Transaction routes - All transaction pages have been removed
  
  // Tools
  { path: "/UpdateGlobalOptions", component: <UpdateGlobalOptions/> },

  // Report routes
  { path: "/LedgerReport", component: <LedgerReport /> },
  { path: "/BalanceSheet", component: <BalanceSheet /> },
  { path: "/ProfitLossReport", component: <ProfitLossReport /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> }, 
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
